/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2016, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/baglass/js/baglass/app/plugins/Button'
], function (BaseClass) {

	const WIDGET_CONTAINER_ID = 'com.ibm.bi.dashboard.widgets';
	const CONTENT_CONTAINER_ID = 'com.ibm.bi.dashboard.contentTypes';

	const CustomWidgetButton = BaseClass.extend({
		init: function (options) {
			CustomWidgetButton.inherited('init', this, arguments);
			const appController = options.glassContext.appController;
			this._determineVisibility(appController);
		},

		_determineVisibility: function (appController) {
			appController.findCollection(WIDGET_CONTAINER_ID)
				.then(collection => {
					const customWidgets = collection.filter(widget => !widget.builtin);
					if (customWidgets.length > 0) {
						return true;
					} else {
						return appController.findCollection(CONTENT_CONTAINER_ID)
							.then( contents => (contents || []).some( content => content.expose ));
					}
				})
				.then((shouldRender) => {
					if (shouldRender) {
						this.show();
					} else {
						// We have no custom widgets/contents so we never want this button to be shown.
						this.hideForever = true;
						this.hide();
					}
				});
		}
	});

	return CustomWidgetButton;
});
